const transformDealerStatusResponse = (response, meta, arg) => {
    var _a;
    const { dealerCode } = (_a = arg.params) !== null && _a !== void 0 ? _a : {};
    return { ...response, dealerCode };
};
export default transformDealerStatusResponse;
export function transformDealerAvailabilityResponse(response) {
    const res = {};
    response.forEach(({ dealerCode, inventoryAvailable }) => {
        res[dealerCode] = inventoryAvailable;
    });
    return res;
}
